import styled, { css } from 'styled-components';

import { InfoBlock } from 'components/info-block';
import { captionRegular, messagesRegular } from 'styles/mixins/fonts';

export const Title = styled.p<{ isInfo?: boolean }>`
  ${({ theme, isInfo }) => css`
    ${isInfo ? captionRegular : messagesRegular};
    color: ${theme.colors.grey.primary.standard};
  `}
`;

export const Container = styled.div`
  gap: 16px;
  display: grid;
  margin: 24px 0;
  grid-auto-rows: 1fr;
  grid-template-columns: ${({ theme }) =>
    `repeat(${theme.responsive.isDesktop ? 4 : theme.responsive.isTablet ? 3 : 1}, 1fr)`};
`;

export const StyledInfoBlock = styled(InfoBlock)`
  svg path {
    fill: ${({ theme }) => theme.colors.blue.primary.standard};
  }
`;
